import { PaymentMethod } from '../models';

export class PaymentMethodSummary {
    public totalCash: number = 0;
    public totalExternalCredit: number = 0;
    public totalCreditCards: number = 0;
    public totalChecks: number = 0;

    private externalArray = ['amex', 'visa', 'mastercard', 'discover', 'other'];

    constructor(public paymentMethod: Array<PaymentMethod>) {
        this._CalculateTotals();
    }

    private _CalculateTotals() {

        this.paymentMethod.forEach(element => {

            let method = element.name.toLowerCase();

            if (method === 'cash') {
                this.totalCash += element.amount;
            }
            else if (this.externalArray.indexOf(method) !== -1) {
                this.totalExternalCredit += element.amount;
            }
            else if (method.indexOf('check') !== -1) {
                this.totalChecks += element.amount;
            }
            else {
                this.totalCreditCards += element.amount;
            }
        });
    }
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounting/shared/models/payment-method-summary.ts